"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initial = initial;
exports.useJson = useJson;
exports.use = use;
exports.refreshToken = refreshToken;
exports.errorHandle = errorHandle;
exports.http = exports.jsonConfig = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _qs = _interopRequireDefault(require("qs"));

var _innerkenJsUtils = _interopRequireDefault(require("innerken-js-utils"));

var _Logger = require("./Logger");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var httpCode = {
  400: 'Parameterfehler anfordern',
  // 请求参数错误
  401: 'Unzureichende Berechtigungen, bitte melden Sie sich erneut an',
  // 权限不足, 请重新登录
  403: 'Der Server verweigert diesen Zugriff',
  // 服务器拒绝本次访问
  404: 'Angeforderte Ressource nicht gefunden',
  // 请求资源未找到
  500: 'Interner Serverfehler',
  // 内部服务器错误
  501: 'Der Server unterstützt die in der Anforderung verwendete Methode nicht',
  // 服务器不支持该请求中使用的方法
  502: 'Gateway-Fehler',
  // 网关错误
  504: 'Gateway-Zeitüberschreitung' // 网关超时

};

var instance = _axios.default.create({
  timeout: 1000 * 30
});

exports.http = instance;
var jsonConfig = {
  headers: {
    post: {
      'Content-Type': 'application/json'
    },
    put: {
      'Content-Type': 'application/json'
    },
    patch: {
      'Content-Type': 'application/json'
    },
    delete: {
      'Content-Type': 'application/json'
    }
  }
};
exports.jsonConfig = jsonConfig;
var defaultHeaderInfo = {
  common: {},
  post: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
  },
  get: {}
};
/**
 *
 * @HilloConfigClass {
 * {isDebug: boolean, responseValidator: (function(*): boolean),
 * tokenKey: string,
 * productionUrl: string,
 * defaultHeader: (function(): {}),
 * tokenRefresh: defaultHilloConfig.tokenRefresh,
 * debugUrl: string,
 * errorHandler: defaultHilloConfig.errorHandler,
 * responseConvertor: (function(*): string),
 * header: (function(*): string)}}
 */

var defaultHilloConfig = function defaultHilloConfig() {
  this.tokenKey = '';
  this.isDebug = true;
  this.productionUrl = '';
  this.debugUrl = '';
  this.header = defaultHeaderInfo;

  this.responseConvertor = res => res;

  this.responseValidator = res => true;

  this.errorHandler = null;

  this.defaultHeader = () => {
    if (HilloConfig.tokenKey) {
      var obj = {};
      obj[HilloConfig.tokenKey] = localStorage.getItem(HilloConfig.tokenKey);
      return obj;
    } else {
      return null;
    }
  };

  this.refreshHeader = () => {
    var headerKey = ['common', 'post', 'get'];
    var header = HilloConfig.header;

    for (var k of headerKey) {
      instance.defaults.headers[k] = Object.assign({}, defaultHeaderInfo[k], header[k], HilloConfig.defaultHeader());
    }

    if (HilloConfig.isDebug) {
      (0, _Logger.hilloLog)('被设置为', 'Header', instance.defaults.headers);
    }
  };

  this.tokenRefresh = value => {
    if (HilloConfig.isDebug) {
      (0, _Logger.hilloLog)('将被设置为', 'token', HilloConfig.tokenKey, value);
    }

    localStorage.setItem(HilloConfig.tokenKey, value);
    HilloConfig.refreshHeader();
  };

  this.LoadingUtils = {
    showLoading: _innerkenJsUtils.default.showLoading,
    hideLoading: () => _innerkenJsUtils.default.toast('', 'ok'),
    showError: _innerkenJsUtils.default.showError
  };
};

var HilloConfig = new defaultHilloConfig();
window.HilloConfig = HilloConfig;
/**
 * 使用某个BaseUrl来初始化本库，一定要调用本函数后才可以使用
 * @param baseUrl
 * @param debug
 */

function initial(baseUrl) {
  var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  use({
    isDebug: debug,
    productionUrl: baseUrl,
    debugUrl: baseUrl,
    header: {
      post: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    }
  });
}

function useJson() {
  instance.defaults.headers = jsonConfig.headers;
}

function responseInterceptor(res) {
  var realData = res.data;

  if (HilloConfig.isDebug && res.config.showDebug) {
    var _config$data;

    var config = res.config;
    (0, _Logger.hilloLog)(config.url + config.method, 'Request');
    (0, _Logger.hilloLog)((_config$data = config.data) !== null && _config$data !== void 0 ? _config$data : "No Data", 'Data');
    (0, _Logger.hilloLog)(realData, 'Result');
  }

  if (HilloConfig.responseValidator(realData)) {
    return Promise.resolve(HilloConfig.responseConvertor(realData));
  } else {
    if (errorHandle(res)) {
      return Promise.resolve(null);
    } else {
      return Promise.reject(res);
    }
  }
}

var version = require('../../package.json').version;
/**
 *
 * @HilloConfigClass config
 */


function use() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new defaultHilloConfig();
  (0, _Logger.hilloLog)('v' + version);
  HilloConfig = Object.assign({}, new defaultHilloConfig(), config);
  instance.defaults.baseURL = HilloConfig.isDebug ? HilloConfig.debugUrl : HilloConfig.productionUrl;
  HilloConfig.refreshHeader();
}

function refreshToken(value) {
  HilloConfig.tokenRefresh(value);
}
/**
 * 请求失败后的错误统一处理
 * @param {Object} error 请求失败
 */


function errorHandle(error) {
  var _error$config;

  if (error === null || error === void 0 ? void 0 : (_error$config = error.config) === null || _error$config === void 0 ? void 0 : _error$config.showLoading) {
    HilloConfig.LoadingUtils.hideLoading(false);
  }

  if (HilloConfig.errorHandler) {
    return HilloConfig.errorHandler(error);
  } else {
    var _error$data$message;

    var status = error.status;
    var tips = status in httpCode ? httpCode[status] : (_error$data$message = error.data.message) !== null && _error$data$message !== void 0 ? _error$data$message : error.data.info;

    if (!error.config.silent) {
      if (tips) {
        HilloConfig.LoadingUtils.showError(tips);
      } else {
        HilloConfig.LoadingUtils.showError();
      }
    }

    return true;
  }
}

function defaultRequestInterceptor(req) {
  if (req.showLoading) {
    HilloConfig.LoadingUtils.showLoading(true);
  }

  if (req.method === 'post') {
    if (req.headers.post['Content-Type'].includes('application/x-www-form-urlencoded')) {
      req.data = _qs.default.stringify(req.data);
    }
  }

  return req;
}

instance.interceptors.request.use(defaultRequestInterceptor, error => Promise.error(error));
instance.interceptors.response.use( // 请求成功
responseInterceptor, error => {
  if (errorHandle(error)) {
    return Promise.resolve(null);
  } else {
    return Promise.reject(error);
  }
});